<ejs-dialog #parkingRangerAssignmentDialog [isModal]="true" [showCloseIcon]="true" [visible]="false">
  <ng-template #header>
    @if (isAdd) {
      {{ 'i18n.domain.parking-ranger-assignment-administration.dialog.add-title' | translate }}
    } @else if (isEdit) {
      {{ 'i18n.domain.parking-ranger-assignment-administration.dialog.edit-title' | translate }}
    } @else {
      {{ 'i18n.domain.parking-ranger-assignment-administration.dialog.delete-title' | translate }}
    }
  </ng-template>
  <ng-template #content>
    <form id="parkingRangerAssignmentForm" [formGroup]="form" autocomplete="off">
      @if (!isEdit) {
        <div class="row">
          <div class="form-group col-6">
            <label class="control-label required">{{'i18n.domain.parking-ranger-assignment-administration.dialog.user' | translate}}</label>
            <app-autocomplete #userAutocomplete [getDataFunction]="getParkingRangers.bind(this)"
              [(value)]="selectedUser" [isFormComponent]="true" placeholder="" id="user">
            </app-autocomplete>
          </div>
          <div class="form-group col-6">
            <label [class.required]="isAdd" class="control-label">{{'i18n.domain.parking-ranger-assignment-administration.dialog.client' | translate}}</label>
            <app-client-autocomplete class="client-autocomplete" [formControl]="form.controls.client"
              placeholder=""></app-client-autocomplete>
            <app-error-messages [control]="form.controls.client"></app-error-messages>
          </div>
        </div>
      }
      @if (isAddOrEdit) {
        <div class="row mt-3">
          <div class="form-group col-6">
            <ejs-checkbox formControlName="isRegistrationCreationEnabled"
              label="{{'i18n.domain.parking-ranger-assignment-administration.dialog.isRegistrationCreationEnabled' | translate}}">
            </ejs-checkbox>
          </div>
          <div class="form-group col-6">
            <ejs-checkbox formControlName="isSessionCreationEnabled"
              label="{{'i18n.domain.parking-ranger-assignment-administration.dialog.isSessionCreationEnabled' | translate}}">
            </ejs-checkbox>
          </div>
        </div>
        <div class="row mt-3">
          <div class="form-group col-6">
            <ejs-checkbox formControlName="isCurrentPositionEnabled"
              label="{{'i18n.domain.parking-ranger-assignment-administration.dialog.isCurrentPositionEnabled' | translate}}">
            </ejs-checkbox>
          </div>
          <div class="form-group col-6">
            <ejs-checkbox formControlName="isPositionTrackingEnabled"
              label="{{'i18n.domain.parking-ranger-assignment-administration.dialog.isPositionTrackingEnabled' | translate}}">
            </ejs-checkbox>
          </div>
        </div>
        <div class="row mt-3">
          <div class="form-group col-6">
            <label class="control-label">{{'i18n.domain.parking-ranger-assignment-administration.dialog.newSessionCreationAfterHours' | translate}}</label>
            <ejs-numerictextbox formControlName="newSessionCreationAfterHours" id="newSessionCreationAfterHours"
              [min]="0" [format]="'n0'" [decimals]="0">
            </ejs-numerictextbox>
          </div>
          <div class="form-group col-6">
            <label class="control-label">{{'i18n.domain.parking-ranger-assignment-administration.dialog.previewConsideredHours' | translate}}</label>
            <ejs-numerictextbox formControlName="previewConsideredHours" id="previewConsideredHours"
              [min]="0" [format]="'n0'" [decimals]="0">
            </ejs-numerictextbox>
          </div>
        </div>
      }
    </form>
    @if (isAdd && form.controls.client.value) {
      <div class="mt-3">
        <ejs-tooltip id='tooltip' content="{{ 'i18n.domain.parking-ranger-assignment-administration.dialog.zone-selection-tooltip' | translate }}">
          <span>{{'i18n.domain.parking-ranger-assignment-administration.dialog.zone-selection' | translate}}</span><span class="icon-information"></span>
        </ejs-tooltip>
        <app-parking-ranger-assignment-edit-zones-selector [clientId]="form.controls.client.value.id"></app-parking-ranger-assignment-edit-zones-selector>
      </div>
    }
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closeDialog()">
      {{'i18n.shared.cancel' | translate}}
    </button>
    <button class="btn btn-primary" (click)="onExecute()" [disabled]="!isEdit && form.invalid">
      {{'i18n.shared.save' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
